<template>
    <div v-loading="loading">
        <div class="common-header">
            <el-input class="common-el-input" placeholder="请输入" v-model="searchVal">
                <template slot="prepend">玩家</template>
            </el-input>
            <el-button type="primary" @click="getDetail">查询</el-button>
        </div>
        <el-card style="margin: 20px 0">
            <strong v-text="`玩家昵称：${userNickname}`"></strong>
        </el-card>
        <el-card>
            <h3 slot="header">活动信息</h3>
            <strong style="line-height: 40px">首充红包</strong>
            <div style="line-height: 40px">
                <p v-text="`是否有活动资格：${eligibility}`"></p>
                <p v-text="`是否完成首充：${completed}`"></p>
                <p v-text="`是否已经领取红包：${received}`"></p>
                <p v-text="`领取红包金豆数额：${chips}`"></p>
            </div>
        </el-card>
    </div>
</template>
<script>
    import {mapActions} from 'vuex';

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                chips: '--',// 领取红包金豆数额
                completed: '--',// 是否已完成首充
                eligibility: '--',// 是否有活动资格
                received: '--',// 是否已领取红包
                userNickname: '',
            }
        },
        methods: {
            ...mapActions('activity', ['getFirstChargeInfo']),
            getDetail() {
                this.loading = true;
                this.getFirstChargeInfo({
                    nickname: this.searchVal,
                    randomId: this.searchVal,
                }).then(res => {
                    this.loading = false;
                    this.chips = res.data.chips;
                    this.completed = res.data.completed ? '是' : '否';
                    this.eligibility = res.data.eligibility ? '是' : '否';
                    this.received = res.data.received ? '是' : '否';
                    this.userNickname = res.data.userNickname;
                }).catch(() => {
                    this.loading = false;
                    this.chips = '--';
                    this.completed = '--';
                    this.eligibility = '--';
                    this.received = '--';
                    this.userNickname = '';
                })
            }
        }
    }
</script>